export enum RegressionType {
  Linear = "linear",
  Exponential = "exponential",
  Logarithmic = "logarithmic"
}
